import {format, parseISO} from 'date-fns';

export type dateOptions = {
    year?: 'numeric' | '2-digit',
    month?: 'numeric' | '2-digit' | 'short',
    day?: 'numeric' | '2-digit',
    hour?: 'numeric' | '2-digit',
    minute?: 'numeric' | '2-digit',
    weekday?: 'narrow' | 'short' | 'long'
}

export function dateToString(date: Date) {
    return date.toLocaleDateString('pt-br').split('/').reverse().join('-');
}

export function formatDate(date: string | Date, options: dateOptions = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
}, currentLanguage = 'de-DE'): string {
    const parseDate = typeof date === 'string' ? parseISO(date) : date;
    return new Date(parseDate).toLocaleDateString(currentLanguage, options);
}

export function formatDateTime(date: string | Date, options: dateOptions = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit'
}, currentLanguage = 'de-DE'): string {
    const parseDate = typeof date === 'string' ? parseISO(date) : date;
    return new Date(parseDate).toLocaleDateString(currentLanguage, options);
}

export function formatTime(date: Date, withSeconds = false): string {
    return format(date, withSeconds ? 'HH:mm:ss' : 'HH:mm');
}

export function getFromToDateString(dateTo: string, dateFrom: string) {
    const to = new Date(dateTo);
    const from = new Date(dateFrom);

    if (to.getTime() !== from.getTime()) {
        const optionFrom: dateOptions = {
            month: '2-digit',
            day: '2-digit'
        };

        return `${formatDate(from, optionFrom)} - ${formatDate(to)}`;
    } else {
        return `${formatDate(to)}`;
    }
}

export function isBefore(thisDate: string | Date, beforeThatDate: string | Date): boolean {
    const dateTimeA = typeof thisDate === 'string' ? parseISO(thisDate) : thisDate;
    const dateTimeB = typeof beforeThatDate === 'string' ? parseISO(beforeThatDate) : beforeThatDate;

    return dateTimeA < dateTimeB;
}

export function isAfter(thisDate: string | Date, afterThatDate: string | Date): boolean {
    const dateTimeA = typeof thisDate === 'string' ? parseISO(thisDate) : thisDate;
    const dateTimeB = typeof afterThatDate === 'string' ? parseISO(afterThatDate) : afterThatDate;

    return dateTimeA > dateTimeB;
}

export function sortDateAsc(thisDate: string | Date, thatDate: string | Date): number {
    const dateTimeA = typeof thisDate === 'string' ? parseISO(thisDate) : thisDate;
    const dateTimeB = typeof thatDate === 'string' ? parseISO(thatDate) : thatDate;

    if (dateTimeB === dateTimeA) {
        return 0;
    }

    return isAfter(dateTimeA, dateTimeB) ? 1 : -1;
}

export const formatLocalDate = (date: Date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // +1 because months are 0-indexed
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
};
